import { useEffect } from 'react';
import i18n from 'i18next';

export function useHtmlLang() {
  useEffect(() => {
    const updateLang = (lng: string) => {
      const htmlLang = lng === 'pt' ? 'pt-BR' : lng;
      document.documentElement.lang = htmlLang;
    };

    updateLang(i18n.language);

    i18n.on('languageChanged', updateLang);

    return () => {
      i18n.off('languageChanged', updateLang);
    };
  }, []);
}